export const setCookie = (name, value, days) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/`;
};

export const getCookie = (name) => {
  const cookieName = `${name}=`;
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }
  return "";
};

export const deleteCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
};

export const checkConsent = () => {
  const consent = localStorage.getItem("cookieConsent");
  if (consent) {
    return JSON.parse(consent);
  }
  return null;
};

export const initializeAnalytics = (consent) => {
  if (consent && consent.analytics) {
    // Initialize Microsoft Clarity
    if (typeof window !== "undefined") {
      (function (c, l, a, r, i, t, y) {
        c[a] =
          c[a] ||
          function () {
            (c[a].q = c[a].q || []).push(arguments);
          };
        t = l.createElement(r);
        t.async = 1;
        t.src = "https://www.clarity.ms/tag/" + "r7fj7exqm9";
        y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t, y);
      })(window, document, "clarity", "script", "r7fj7exqm9");
    }
  } else {
    // Remove Microsoft Clarity if consent is revoked
    if (typeof window !== "undefined" && window.clarity) {
      window.clarity = undefined;
      const clarityScript = document.querySelector('script[src*="clarity.ms"]');
      if (clarityScript) {
        clarityScript.remove();
      }
    }
  }
};
